var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBxAttributes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27776_76513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27776_76513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 10.8359H15.8332V9.16927H11.6665V10.8359ZM11.6665 8.33594H15.8332V6.66927H11.6665V8.33594ZM4.1665 13.3359H10.8332V12.8776C10.8332 12.2526 10.5276 11.7561 9.9165 11.388C9.30539 11.02 8.49984 10.8359 7.49984 10.8359C6.49984 10.8359 5.69428 11.02 5.08317 11.388C4.47206 11.7561 4.1665 12.2526 4.1665 12.8776V13.3359ZM7.49984 10.0026C7.95817 10.0026 8.35053 9.83941 8.67692 9.51302C9.00331 9.18663 9.1665 8.79427 9.1665 8.33594C9.1665 7.8776 9.00331 7.48524 8.67692 7.15885C8.35053 6.83247 7.95817 6.66927 7.49984 6.66927C7.0415 6.66927 6.64914 6.83247 6.32275 7.15885C5.99637 7.48524 5.83317 7.8776 5.83317 8.33594C5.83317 8.79427 5.99637 9.18663 6.32275 9.51302C6.64914 9.83941 7.0415 10.0026 7.49984 10.0026ZM3.33317 16.6693C2.87484 16.6693 2.48248 16.5061 2.15609 16.1797C1.8297 15.8533 1.6665 15.4609 1.6665 15.0026V5.0026C1.6665 4.54427 1.8297 4.15191 2.15609 3.82552C2.48248 3.49913 2.87484 3.33594 3.33317 3.33594H16.6665C17.1248 3.33594 17.5172 3.49913 17.8436 3.82552C18.17 4.15191 18.3332 4.54427 18.3332 5.0026V15.0026C18.3332 15.4609 18.17 15.8533 17.8436 16.1797C17.5172 16.5061 17.1248 16.6693 16.6665 16.6693H3.33317ZM3.33317 15.0026H16.6665V5.0026H3.33317V15.0026Z",
    fill: "#74788D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxAttributes);
export default __webpack_public_path__ + "static/media/bx-attributes.aa1b7fa39886f8672fd07cd185f11390.svg";
export { ForwardRef as ReactComponent };